import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useLoginRedirectPath } from "shared/hooks";

export const Auth0WithNavigate = ({ children }: PropsWithChildren) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { clearLoginRedirectPath, getLoginRedirectPath, setLoginRedirectPath } =
    useLoginRedirectPath();
  const location = useLocation();
  const navigate = useNavigate();

  if (!getLoginRedirectPath() && location.pathname !== "/app") {
    setLoginRedirectPath(location.pathname);
  }

  const redirectCallback = () => {
    setSearchParams({});
    const returnPath = getLoginRedirectPath();
    if (returnPath) {
      clearLoginRedirectPath();
      navigate(returnPath);
    }
  };

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        redirect_uri: `${window.location.origin}/app`,
        login_hint: searchParams.get("email")?.toLowerCase() ?? undefined,
      }}
      onRedirectCallback={redirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};
